import { Component } from 'react';
import { Tooltip } from 'react-tooltip';
import { withTranslation } from 'react-i18next';

class NoDiscover extends Component {
    constructor() {
        super();

        this.updateInput = this.updateInput.bind(this);

        this.state = {
            domainCount: 10,
        };
    }

    updateInput(value) {
        this.setState({ domainCount: value });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="card">
                    <div className="card-body p-24">
                        <div className="ai-tracking-no-linked-accounts">
                            <div className="ai-tracking-no-linked-accounts-header">
                                {t('ai_tracking.global.no_discover_data_header')}
                            </div>
                            <div className="ai-tracking-no-linked-accounts-subheader">
                                {t('ai_tracking.global.no_discover_data_subheader')}
                            </div>
                            <div className="ai-tracking-no-discover">
                                <div className="w-100">
                                    <div className="ai-tracking-no-discover-header">
                                        <div className="ai-tracking-no-discover-header-left">
                                            <img src="/static/img/google_discover.svg" />
                                            <div>{t('ai_tracking.global.google_discover')}</div>
                                        </div>
                                        <div
                                            className="txt-helper"
                                            data-tooltip-id="discover-info-tooltip"
                                        >
                                            <img src="/static/img/gd dash logo-horizontal-blue.svg" />{' '}
                                            {t('ai_tracking.global.see_what_included')}
                                        </div>
                                    </div>
                                    <div className="ai-tracking-no-discover-subheader">
                                        {t('ai_tracking.global.no_discover_data_text')}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between w-100">
                                    <div className="d-flex gap-10 align-items-center">
                                        <div className="ai-tracking-no-discover-input">
                                            <button
                                                className="count-btn"
                                                onClick={() =>
                                                    this.updateInput(this.state.domainCount - 1)
                                                }
                                            >
                                                -
                                            </button>
                                            <input
                                                type="number"
                                                value={this.state.domainCount}
                                                onChange={(e) => this.updateInput(e.target.value)}
                                            />
                                            <button
                                                className="count-btn"
                                                onClick={() =>
                                                    this.updateInput(this.state.domainCount + 1)
                                                }
                                            >
                                                +
                                            </button>
                                        </div>
                                        <div className="ai-tracking-no-discover-input-label">
                                            {t('ai_tracking.global.domains')}
                                        </div>
                                    </div>
                                    <div className="d-flex gap-16 align-items-center">
                                        <div>
                                            <div className="ai-tracking-no-discover-price">
                                                +$100
                                            </div>
                                            <div className="ai-tracking-no-discover-price-text">
                                                {t('ai_tracking.global.to_current_plan')}
                                            </div>
                                        </div>
                                        <button className="button button-filled button-primary">
                                            {' '}
                                            {t('ai_tracking.global.add_google_discover')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Tooltip id="discover-info-tooltip" place="bottom" className="custom-tooltip">
                    <div className="custom-tooltip-content">
                        <strong>{t('ai_tracking.global.ai_tracking')}</strong>
                        <div className="custom-tooltip-content-description">
                            {t('ai_tracking.global.ai_tracking_description')}{' '}
                        </div>
                        <div className="custom-tooltip-content-products">
                            <div className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src="/static/img/google_discover.svg" />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">
                                        {t('ai_tracking.global.google_discover_analytics')}
                                    </div>
                                    <div className="description">
                                        {t(
                                            'ai_tracking.global.google_discover_analytics_description',
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src="/static/img/google_discover.svg" />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">
                                        {t('ai_tracking.global.google_discover_analytics')}
                                    </div>
                                    <div className="description">
                                        {t(
                                            'ai_tracking.global.google_discover_analytics_description',
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src="/static/img/google_discover.svg" />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">
                                        {t('ai_tracking.global.google_discover_analytics')}
                                    </div>
                                    <div className="description">
                                        {t(
                                            'ai_tracking.global.google_discover_analytics_description',
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src="/static/img/google_discover.svg" />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">
                                        {t('ai_tracking.global.google_discover_analytics')}
                                    </div>
                                    <div className="description">
                                        {t(
                                            'ai_tracking.global.google_discover_analytics_description',
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src="/static/img/google_discover.svg" />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">
                                        {t('ai_tracking.global.google_discover_analytics')}
                                    </div>
                                    <div className="description">
                                        {t(
                                            'ai_tracking.global.google_discover_analytics_description',
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src="/static/img/google_discover.svg" />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">
                                        {t('ai_tracking.global.google_discover_analytics')}
                                    </div>
                                    <div className="description">
                                        {t(
                                            'ai_tracking.global.google_discover_analytics_description',
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tooltip>
            </>
        );
    }
}

export default withTranslation()(NoDiscover);
